<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Start Day</p>
  </div>
  <div>
    <button type="button" mat-dialog-close mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>

<form nz-form (ngSubmit)="onSubmit()" [formGroup]="startDayFrom">
  <div mat-dialog-content>
    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Start Time</nz-form-label>
        <nz-form-control nzErrorTip="Start time is required!">
          <nz-date-picker class="w-100" formControlName="startTime" nzPlaceHolder="Start time"
                          [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"></nz-date-picker>
        </nz-form-control>
      </div>
    </nz-form-item>
    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Start Cash Amount</nz-form-label>
        <nz-form-control nzErrorTip="Cash amount is required!">
          <nz-input-number class="w-100" nzId="startCash" formControlName="startCash"
                           nzPlaceHolder="Start cash amount"></nz-input-number>
        </nz-form-control>
      </div>
    </nz-form-item>
  </div>

  <div class="mt-4 d-flex justify-content-end mb-4 me-4">
    <button type="button" class="small-btn-width btn-radius me-2" mat-dialog-close nzType="primary" nzGhost nz-button>
      Cancel
    </button>
    <button type="submit" nz-button nzType="primary" class="small-btn-width btn-radius">
      Submit
    </button>
  </div>
</form>
